import { CLEAN, ERROR_SERVER, GET_VEHICLES, IS_FETCHING, IS_FETCHING_SHOW_MORE, SET_ACCESS_VEHICLES_SELECTED, SET_VISIT_VEHICLE_SELECTED } from "./types";

const AccessVehiclesReducer = (state, action) => {
    const { type, payload } = action;
    switch (type) {
        case CLEAN:
            return {
                ...state,
                accessVehicles: [],
                isFetching: true,
                isFetchingShowMore: false,
                canShowMore: false,
                error: false,
                message: '',
                reg_to: 1,
                accessVehiclesSelected: [],
                initialStateVisitVehicle: {
                    plate_number: '',
                    observations: '',
                    description: '',
                }
            }
        case GET_VEHICLES:
            return {
                ...state,
                accessVehicles: payload.vehicles,
                isFetching: false,
                error: false,
                message: '',
                reg_to: payload.reg_to,
                canShowMore: payload.canShowMore,
                isFetchingShowMore: false,
            }
        case IS_FETCHING:
            return {
                ...state,
                isFetching: true,
                error: false,
                message: ''
            }
        case IS_FETCHING_SHOW_MORE:
            return {
                ...state,
                isFetchingShowMore: true,
                error: false,
                message: ''
            }
        case ERROR_SERVER:
            return {
                ...state,
                isFetching: false,
                isFetchingShowMore: false,
                error: true,
                message: payload
            }
        case SET_ACCESS_VEHICLES_SELECTED:
            return {
                ...state,
                accessVehiclesSelected: payload,
                initialStateVisitVehicle: {
                    plate_number: '',
                    observations: '',
                    description: '',
                }
            }
        case SET_VISIT_VEHICLE_SELECTED:
            return {
                ...state,
                initialStateVisitVehicle: payload
            }
        default:
            return state
    }
}

export default AccessVehiclesReducer